export default "__VITE_PUBLIC_ASSET__45c639a7__"